import { MbmCustomer } from '../types/mbm-project.types';

/** Collapses project rows to one entry per customer id, keeping the first name seen. */
export const toDistinctCustomers = (rows: MbmCustomer[]): MbmCustomer[] => {
  const byId = new Map<string, MbmCustomer>();
  rows.forEach((row) => {
    if (row.CustomerId && !byId.has(row.CustomerId)) {
      byId.set(row.CustomerId, { CustomerId: row.CustomerId, CustomerName: row.CustomerName });
    }
  });
  return Array.from(byId.values()).sort((a, b) => a.CustomerName.localeCompare(b.CustomerName));
};
